import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    meta: {
      layout: 'landing',
      requiresAuth: false,
    },
    component: () => import('./PIndex.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      layout: 'default',
      title: 'dashboard',
      requiresAuth: true,
    },
    component: () => import('./PDashboard.vue'),
  },
  {
    path: '/profit-calculator',
    name: 'ProfitCalculator',
    meta: {
      layout: 'default',
      title: 'profit_calculator',
      requiresAuth: true,
    },
    component: () => import('./PProfitCalculator.vue'),
  },
  {
    path: '/reviews-management',
    name: 'ReviewsManagement',
    meta: {
      layout: 'default',
      title: 'reviews_management',
      requiresAuth: true,
    },
    component: () => import('./PReviewsManagement.vue'),
  },
  {
    path: '/supply-management',
    name: 'SupplyManagement',
    meta: {
      layout: 'default',
      title: 'supply_management',
      requiresAuth: true,
    },
    component: () => import('./PSupplyManagement.vue'),
  },
  {
    path: '/repacker',
    name: 'Repacker',
    meta: {
      layout: 'default',
      title: 'repacker',
      requiresAuth: true,
    },
    component: () => import('./PRepacker.vue'),
  },
  {
    path: '/auto-bidder',
    name: 'AutoBidder',
    meta: {
      layout: 'default',
      title: 'auto_bidder',
      requiresAuth: true,
    },
    component: () => import('./PAutoBidder.vue'),
  },
  {
    path: '/ai',
    name: 'AI',
    meta: {
      layout: 'default',
      title: 'chat_with_ai',
    },
    component: () => import('./PAI.vue'),
  },
  {
    path: '/ai/:id',
    name: 'AIConversation',
    meta: {
      layout: 'default',
      title: 'chat_with_ai',
    },
    component: () => import('./PAIConversation.vue'),
  },
  {
    path: '/suppliers-catalog',
    name: 'SuppliersCatalog',
    meta: {
      layout: 'default',
      title: 'suppliers_catalog',
      requiresAuth: true,
    },
    component: () => import('./PSuppliersCatalog.vue'),
  },
  {
    path: '/services-and-courses',
    name: 'ServicesAndCourses',
    meta: {
      layout: 'default',
      title: 'services_and_courses',
      requiresAuth: true,
    },
    component: () => import('./PServicesAndCourses.vue'),
  },
  {
    path: '/suggest-idea',
    name: 'SuggestIdea',
    meta: {
      layout: 'default',
      title: 'suggest_idea',
      requiresAuth: true,
    },
    component: () => import('./PSuggestIdea.vue'),
  },
  {
    path: '/tariffs',
    name: 'Tariffs',
    meta: {
      layout: 'default',
      title: 'tariffs',
      requiresAuth: true,
    },
    component: () => import('./PTariffs.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      layout: 'default',
      title: 'profile',
      requiresAuth: true,
    },
    component: () => import('./PProfile.vue'),
  },
  {
    path: '/notifications',
    name: 'Notifications',
    meta: {
      layout: 'default',
      title: 'notifications',
      requiresAuth: true,
    },
    component: () => import('./PNotifications.vue'),
  },
  {
    // Clean canonical paths for legal pages. The edge proxy routes `/static*`
    // (incl. the old `/static-page/*`) to Django, so those 404 on hard nav;
    // these slugs fall back to the SPA and also match the addresses cited in
    // the documents themselves (e.g. marketassist.ru/privacy).
    path: '/:slug(privacy|terms-of-use|cookie-policy|consent)',
    name: 'StaticPage',
    meta: {
      layout: 'landing',
      requiresAuth: false,
    },
    component: () => import('./PStaticPage.vue'),
  },
  {
    // Back-compat: redirect the legacy /static-page/:slug path to the clean URL.
    path: '/static-page/:slug',
    redirect: to => ({ name: 'StaticPage', params: { slug: to.params.slug } }),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: {
      layout: 'landing',
      requiresAuth: false,
    },
    component: () => import('./PError.vue'),
  },
]

export { routes }
